export default __webpack_public_path__ + "static/media/cny-promo.569bd4e4.webp";